module.exports = __webpack_public_path__ + "static/media/main_visual_rough_terrain_m_40_2_st5_manitou.aa63c601.png";